import "core-js/modules/es6.string.fixed.js";
import "core-js/modules/es6.array.map.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import isEmpty from 'lodash/isEmpty';
import { defaultProps, ALIGN } from './api';
import { TableCell, CELL_ELEMENTS } from './TableCell';
import styles from './Table.module.less';
export var wrapWithAlign = function wrapWithAlign(align, children) {
  if (!align || !ALIGN[align]) return children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles["align-".concat(ALIGN[align])]
  }, children);
};
export var BaseTable = function BaseTable(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      data = _ref.data,
      hasTableHeader = _ref.hasTableHeader,
      striped = _ref.striped,
      ariaLabel = _ref['aria-label'],
      ariaLabelledBy = _ref['aria-labelledby'];

  if (isEmpty(columns) || isEmpty(data)) {
    return null;
  } // Tracks where we are in a colSpan


  var curColSpan = 0;
  return /*#__PURE__*/React.createElement("table", {
    className: classNames(styles.table, className),
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy // All components need to be keyboard usable, `tabIndex="0"`
    // is a rare acceptable exception
    // https://dequeuniversity.com/rules/axe/3.5/scrollable-region-focusable?application=axeAPI
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    ,
    tabIndex: "0"
  }, hasTableHeader && /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: styles.stripedBackground
  }, columns.map(function (column, index) {
    curColSpan -= 1;
    if (curColSpan > 0) return undefined;
    if (column.colSpan) curColSpan = column.colSpan; // only the first column can be fixed

    var isFixedColumn = index === 0 && column.fixed;
    return /*#__PURE__*/React.createElement(TableCell, {
      element: CELL_ELEMENTS.TH,
      key: column.id,
      className: classNames(column.className, _defineProperty({}, styles.fixedHeader, isFixedColumn)),
      width: column.width,
      scope: "col",
      colSpan: column.colSpan
    }, wrapWithAlign(column.align, column.heading));
  }))), /*#__PURE__*/React.createElement("tbody", null, data.map(function (row, index) {
    curColSpan = 0;
    return /*#__PURE__*/React.createElement("tr", {
      key: row.key,
      className: classNames([styles.tr, _defineProperty({}, styles.stripedBackground, striped && index % 2 !== 0)])
    }, columns.map(function (column, columnIndex) {
      var _classNames2;

      var colSpan = get(row, ['colSpans', column.id]);
      curColSpan -= 1;
      if (curColSpan > 0) return undefined;
      if (colSpan) curColSpan = colSpan; // only the first column can be fixed

      var isFixedColumn = columnIndex === 0 && column.fixed;
      return /*#__PURE__*/React.createElement(TableCell, {
        key: column.id,
        element: column.rowHeader ? CELL_ELEMENTS.TH : CELL_ELEMENTS.TD,
        className: classNames(column.className, row.className, (_classNames2 = {}, _defineProperty(_classNames2, styles.fixedRow, isFixedColumn), _defineProperty(_classNames2, styles.stripedBackground, striped && index % 2 !== 0), _classNames2)),
        colSpan: colSpan
      }, wrapWithAlign(row.align || column.align, get(row, column.id)));
    }));
  })));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, react/forbid-foreign-prop-types
  var _require = require('./api'),
      propTypes = _require.propTypes;

  BaseTable.propTypes = propTypes;
}

BaseTable.defaultProps = defaultProps;